// Placeholder empty state for tracking tabs (Insurances, Deliverables,
// Milestones, Meetings, KPIs). Rendered until PRs 9 and 10 ship the real
// tab content. Shows a large icon + "No X recorded yet" body copy.

import type { LucideIcon } from "lucide-react";
import type { TabLevelType } from "../../../types";
import { TRACKING_TYPE_LABELS } from "../../../types";

interface TrackingTabPlaceholderProps {
  type: TabLevelType;
  icon: LucideIcon;
}

export default function TrackingTabPlaceholder({
  type,
  icon: Icon,
}: TrackingTabPlaceholderProps) {
  const label = TRACKING_TYPE_LABELS[type];
  return (
    <div
      data-testid={`tracking-placeholder-${type}`}
      className="flex flex-col items-center justify-center py-16 text-center"
    >
      <div className="rounded-xl bg-slate-100 dark:bg-slate-800 p-4 mb-4">
        <Icon
          className="h-8 w-8 text-slate-400 dark:text-slate-500"
          aria-hidden="true"
        />
      </div>
      <p className="text-body text-slate-700 dark:text-slate-200 font-medium">
        No {label.toLowerCase()} recorded yet
      </p>
      <p className="text-body-sm text-slate-500 dark:text-slate-400 mt-1">
        This tab will be available soon.
      </p>
    </div>
  );
}
